(() => {
  const offer = document.querySelector('#exit-offer');
  if (!offer || typeof offer.showModal !== 'function') return;

  const seenKey = 'pine-bros-exit-offer-seen';
  const wasSeen = () => {
    try {
      return sessionStorage.getItem(seenKey) === '1';
    } catch {
      return false;
    }
  };
  const markSeen = () => {
    try {
      sessionStorage.setItem(seenKey, '1');
    } catch {
      // The open dialog still prevents repeated triggers in this page view.
    }
  };
  const showOffer = () => {
    if (offer.open || wasSeen()) return;
    markSeen();
    offer.showModal();
  };

  const posted = new URLSearchParams(window.location.search).has('offer');
  if (posted && offer.querySelector('[data-offer-success]')) {
    offer.showModal();
    markSeen();
  } else if (window.matchMedia('(hover: hover) and (min-width: 900px)').matches) {
    document.addEventListener('mouseout', (event) => {
      if (event.relatedTarget === null && event.clientY <= 0) showOffer();
    });

    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentY = window.scrollY;
      if (lastY - currentY >= 40 && currentY <= 120) showOffer();
      lastY = currentY;
    }, { passive: true });
  }

  offer.addEventListener('click', (event) => {
    if (event.target === offer) offer.close();
  });

  offer.querySelector('[data-copy-offer-code]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    const code = offer.querySelector('#exit-offer-code')?.textContent?.trim();
    if (!code || !navigator.clipboard?.writeText) return;
    await navigator.clipboard.writeText(code);
    button.textContent = 'Copied';
  });
})();
